import React from 'react';

var ShareCloneTransferButtonSet = React.createClass({

  getInitialState: function(){
    return {"tooltipClas": "tooltip tooltip--left tooltip--sm"}
  },

  componentDidMount: function () {
      document.addEventListener('click', this.handleClick, false);

      //function for site-nav 
    $('.site__nav-inner-dropdown').hide(); 
    $(".site__nav-inner-toggle").addClass("toggle");  
    $(".site__nav-inner-toggle").unbind('click');

    $('.site__nav-inner-toggle').click(function(e) {                
           e.preventDefault();
           e.stopPropagation();
           $('.site__nav-inner-dropdown').toggle();  
           $(".site__nav-inner-toggle").toggleClass("toggle");
           if($(this).text() == 'Hide'){
               $(this).text('Advanced');
             } else {
               $(this).text('Hide');
             }            
    });

      $(window).bind('resize orientationchange', function() {
          $(".site__nav-inner-toggle").unbind('click');
           $('.site__nav-inner-toggle').click(function(e) {                
               e.preventDefault();
               e.stopPropagation();
               $('.site__nav-inner-dropdown').toggle();  
         $(".site__nav-inner-toggle").toggleClass("toggle");
         
         if($(this).text() == 'Hide'){
             $(this).text('Advanced');
           } else {
             $(this).text('Hide');
           }            
      });  
  
    });

    $(document).click(function(e) {       
     var $clicked = $(e.target);
       if ($clicked.closest('.site__nav').length < 1) {
                $('.site__nav-inner-dropdown').hide();
                $('.site__nav-inner-toggle').text("Advanced");
                if(! $(".site__nav-inner-toggle").hasClass("toggle")){
                  $(".site__nav-inner-toggle").addClass("toggle")
                }
           }
    }); 

    window.addEventListener('resize', this.handleResize); // for changing list view to grid view
  },
  componentWillUnmount: function () {
      document.removeEventListener('click', this.handleClick, false);
       window.removeEventListener('resize', this.handleResize); 
  },
  handleClick: function (e) {
      var $clicked = $(e.target);
      if ($clicked.closest('.site__nav').length < 1) {
          $('.site__nav-dropdown').hide();
      }
  },
  handleSiteNavClick : function (){
     $('.site__nav-dropdown').toggle();  //opens dropdown
  },
  handleCloneClick: function(){
    this.props.clone("open");
    $('.site__nav-dropdown').toggle();
  },
  handleShareClick: function(){
    this.props.sharePackage("open");
    $('.site__nav-dropdown').toggle();
  },
  handleTransferClick: function(){
    this.props.transferPackage("open");
    $('.site__nav-dropdown').toggle();
  },
  handleSnapshotClick: function(){
    this.props.snapshot("open");
    $('.site__nav-dropdown').toggle();
  },
  handleResize: function(e){
    this.setState({windowWidth: window.innerWidth}); // for changing list view to grid view
    if(this.state.windowWidth <= 1219)
    {
      this.setState({"tooltipClas": "tooltip tooltip--right tooltip--sm"});
    } else {
      this.setState({"tooltipClas": "tooltip tooltip--left tooltip--sm"});
    }
  },
  handleUpdateClick: function(){
    this.props.updatePackage("open");
  },
	render: function(){
    var aquisitions = this.props.aquisitions;
    var activeClass;
    // if(this.props.active == this.props.data["user"] + "/" + this.props.data["slug"]){
    if(localStorage.getItem("active_theme") === this.props.account + "/" +  this.props.slug){
      activeClass = "active__btn";
    } else{
      activeClass = "";
    }
    if(!localStorage.session_key){
      var cloneShow = true;
    } else {
      var cloneShow = false;
    }
		return(
        <ul>
          <li className= {activeClass}>
            <a href="javascript:void(0)" className="site__nav-toggle" onClick = {this.handleSiteNavClick}>
              <i className="fa  fa-chevron-circle-down"></i>
            </a>
            <ul className="site__nav-dropdown">
              {/* cloneShow ? */}
              <li className="tooltip__container" onClick = {this.handleCloneClick}><a href="javascript:void(0)"><i className="fa fa-clone"> </i> Clone</a> <span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
              {/* aquisitions.push ?*/}
              <li className="tooltip__container" onClick = {this.props.handlePushClick}><a href="javascript:void(0)"><i className="fa fa-cloud-upload"> </i> Push</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
              {/*aquisitions.pull ?*/}
              <li className="tooltip__container" onClick = {this.props.handlePullClick}><a href="javascript:void(0)"><i className="fa fa-cloud-download"> </i> Pull</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
              <li>
                <ul className="site__nav-inner-dropdown">
                 {/* <li className="tooltip__container" onClick = {this.props.handleCloneByVersionClick}><a href="javascript:void(0)"><i className="fa fa-copy"> </i> Clone by Version</a><span className={this.state.tooltipClas}>Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container" onClick = {this.props.handlePullByVersionClick}><a href="javascript:void(0)"><i className="fa fa-cloud-download"> </i> Pull by Version</a><span className={this.state.tooltipClas}>Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>*/}
                  <li className="tooltip__container" onClick = {this.handleSnapshotClick}><a href="javascript:void(0)"><i className="fa fa-camera"> </i> Snapshot</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container" onClick = {this.handleShareClick}><a href="javascript:void(0)"><i className="fa fa-share-alt"> </i> Share</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  {/*<li className="tooltip__container" onClick = {this.handleTransferClick}><a href="javascript:void(0)"><i className="fa fa-exchange"> </i> Transfer</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container" onClick = {this.handleUpdateClick}><a href="javascript:void(0)"><i className="fa fa-exchange"> </i> Update</a><span className="tooltip tooltip--right tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container"><a href="javascript:void(0)"><i className="fa fa-globe"> </i> Publish</a><span className={this.state.tooltipClas}>Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container" onClick = {this.props.handleInstallClick}><a href="javascript:void(0)"><i className="fa fa-cogs"> </i> Install</a><span className={this.state.tooltipClas}>Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
                  <li className="tooltip__container"><a href="javascript:void(0)"><i className="fa fa-question"> </i> Help</a><span className={this.state.tooltipClas}>Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>*/}
                </ul>
                <a href="javascript:void(0)" className="site__nav-inner-toggle">Advanced <i className="fa"> </i> </a> 
              </li>
            </ul>
          </li>
        </ul>
		);
	}
})

export {ShareCloneTransferButtonSet};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ShareCloneTransferButtonSet.jsx
 **/